import * as React from 'react';
import type { SVGProps } from 'react';

/**
 * Custom colored AI Search icon
 * Purple/magenta with sparkles - AI powered search
 */
const SvgCustomAiSearch = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='1em'
		height='1em'
		viewBox='0 0 24 24'
		className='svg-icon'
		{...props}>
		{/* Search circle */}
		<circle cx='10' cy='10' r='7' fill='none' stroke='#e040fb' strokeWidth='2.5' />
		<path d='M15 15l5.5 5.5' stroke='#e040fb' strokeWidth='2.5' strokeLinecap='round' />
		{/* AI sparkles */}
		<circle cx='7' cy='7' r='1' fill='#00e5ff' />
		<circle cx='13' cy='8' r='1' fill='#00e5ff' />
		<circle cx='10' cy='13' r='1' fill='#00e5ff' />
		{/* AI accent star */}
		<path d='M10 5v2M10 13v2M5 10h2M13 10h2M7 7l1.5 1.5M11.5 11.5l1.5 1.5M7 13l1.5-1.5M11.5 8.5l1.5-1.5' stroke='#76ff03' strokeWidth='0.8' strokeLinecap='round' />
	</svg>
);

export default SvgCustomAiSearch;
